import type { AnnotatedSegment } from '@/util/AnnotatedSegment'
import type { AnnotatedSentence } from '@/util/AnnotatedSentence'
import type { AnnotatedWord } from '@/util/AnnotatedWord'

type SegmentPredicate = (
  annotatedSentence: AnnotatedSentence | null,
  annotatedSegment: AnnotatedSegment | null,
  sentenceIndex: number,
  segmentIndex: number,
) => boolean

type WordPredicate = (
  annotatedSentence: AnnotatedSentence | null,
  annotatedSegment: AnnotatedSegment | null,
  annotatedWord: AnnotatedWord,
  sentenceIndex: number,
  segmentIndex: number,
  wordIndex: number,
) => boolean

/**
 * Adapt a per-segment predicate to AnnotatedText's per-word callbacks (e.g. `clickableWord`):
 * a word answers exactly as its segment does.
 */
export function segmentPredicateAsWordPredicate(predicate: SegmentPredicate): WordPredicate {
  return (annotatedSentence, annotatedSegment, _annotatedWord, sentenceIndex, segmentIndex) =>
    predicate(annotatedSentence, annotatedSegment, sentenceIndex, segmentIndex)
}
